// ===================================================
// OfflineBanner.js — 오프라인 상태 안내 배너
//
// network.js의 initNetworkWatcher가 오프라인 감지 시
// 화면 상단에 고정으로 표시되는 배너입니다.
//
// AI 기능(GPT)과 데이터 저장(Supabase) 모두 인터넷이
// 필요하므로, 오프라인 상태를 사전에 안내합니다.
// ===================================================

import './OfflineBanner.css';

function OfflineBanner() {
  return (
    <div className="offline-banner" role="alert">
      <span className="offline-banner-icon">⚡</span>
      <span className="offline-banner-text">
        오프라인 상태 — AI 기능과 저장이 일시 중단됩니다
      </span>
    </div>
  );
}

export default OfflineBanner;
